import React from 'react';
import './ServiceCard.css';

const ServiceCard = ({ service, onServiceClick }) => {
  const { title, description, image, price, features, rating } = service;

  const handleViewDetails = () => {
    if (onServiceClick && typeof onServiceClick === 'function') {
      onServiceClick();
    }
  };

  return (
    <div className="service-card fade-in">
      <div className="service-image">
        {image ? (
          <>
            <img src={image} alt={title} />
            <div className="service-overlay">
              <button 
                className="btn btn-primary"
                onClick={handleViewDetails}
              >
                View Details
              </button>
            </div>
          </>
        ) : (
          <div className="no-image-placeholder">
            <div className="no-image-content">
              <span className="no-image-icon">📋</span>
              <span className="no-image-text">No Image</span>
            </div>
            <div className="service-overlay">
              <button 
                className="btn btn-primary"
                onClick={handleViewDetails}
              >
                View Details
              </button>
            </div>
          </div>
        )}
      </div>
      
      <div className="service-content">
        <div className="service-header">
          <h3 className="service-title">{title}</h3>
          <div className="service-rating">
            <span className="rating-stars">
              {Array.from({ length: 5 }, (_, i) => (
                <span key={i} className={`star ${i < Math.floor(rating) ? 'filled' : ''}`}>
                  ★
                </span>
              ))}
            </span>
            <span className="rating-value">({rating})</span>
          </div>
        </div>
        
        <p className="service-description">{description}</p>
        
        <div className="service-features">
          <h4 className="features-title">What's Included:</h4>
          <ul className="features-list">
            {features.map((feature, index) => (
              <li key={index} className="feature-item">
                <span className="feature-check">✓</span>
                {feature}
              </li>
            ))}
          </ul>
        </div>
        
        <div className="service-footer">
          <div className="service-price">{price}</div>
          <div className="service-buttons">
            <button 
              className="btn btn-primary"
              onClick={handleViewDetails}
            >
              View Details
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;